import { moveItemInArray } from '@angular/cdk/drag-drop';

/** Returns a reordered copy so drag/drop cannot mutate a parent store value. */
export function reorderMenu<T>(
  menu: readonly T[],
  previousIndex: number,
  currentIndex: number,
): T[] {
  const reordered = [...menu];
  moveItemInArray(reordered, previousIndex, currentIndex);
  return reordered;
}
